import { privateRequest, type ApiResponse } from "../axios";

const ENDPOINTS = {
    GET_ASSET_GROUP: "api/AssetGroups/GetAll",
    ADD_ASSET_GROUP: "api/AssetGroup",
    DELETE_GROUP: "api/AssetGroups",
    GET_ASSET_GROUP_IDS: "api/AssetGroups/GroupIds",
    GET_ASSET_ITEMS: "api/AssetItems/GetAll",
    ADD_ASSET_ITEMS: "api/AssetItem",
    ASSET_ITEMS_BY_ID: "api/AssetItems",
    GET_ASSET_ITEMS_VENDOR: "api/AssetItems/Vendors",
    UPDATE_ASSET_ITEMS_BULK_UPLOAD: "api/AssetItems/BulkUpload",
    ASSET_ITEMS_BULK_UPLOAD_FILES: "api/AssetItems/BulkUpload/Files",
    ASSET_ITEMS_BULK_UPLOAD_REPORT: "api/AssetItems/BulkUpload/Report",
    ASSET_ITEMS_BULK_UPLOAD_LOGS: "api/AssetItems/BulkUpload/Logs",
    GET_ASSET_LOCATION: "api/AssetLocations/GetAll",
    ADD_ASSET_LOCATION: "api/AssetLocation",
    DELETE_LOCATION: "api/AssetLocations",
    GET_ASSET_TYPE: "api/AssetTypes/GetAll",
    ADD_ASSET_TYPE: "api/AssetType",
    DELETE_TYPE: "api/AssetTypes",
    GET_LOCATION_NAME: "api/AssetLocations/Names",
    GET_LOCATION_TYPE: "api/AssetLocations/Types",
    GET_TYPE_NAME: "api/AssetTypes/Names",
    GET_ASSET_ITEM_NAME: "api/AssetItems/Names",
    GET_ALLOCATION_GROUPS: "api/AssetGroups/Groups",
    GET_ALLOCATION_ITEM: "api/AssetAllocations/GetAll",
    UPDATE_ALLOCATION_ITEM: "api/AssetAllocation",
    ALLOCATION_EXPORT: "api/AssetAllocations/DetailsReport",
    ITEM_EXPORT: "api/AssetItems/DetailsReport",
    EXPORT_FILE: "api/AssetItems/BulkUpload/ExportFile",
    EXPORT_ALLOCATION_TYPE: "api/AssetTypes/DetailsReport",
    EXPORT_ALLOCATION_GROUP: "api/AssetGroups/GroupsExport",
    EXPORT_GROUP: "api/AssetGroups/DetailsReport",
    EXPORT_LOCATION: "api/AssetLocations/Report",
    EXPORT_TYPE: "api/AssetTypes/Export",
    ALLOCATION_LOGS: "api/AssetAllocations/Logs",
};

const getAssetAllGroups = async (data: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.GET_ASSET_GROUP, data);
    return res.data;
};

const addAssetGroup = async (data: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.ADD_ASSET_GROUP, data);
    return res.data;
};

const deleteGroupById = async (id: number): Promise<ApiResponse<any>> => {
    const res = await privateRequest.delete<ApiResponse<any>>(`${ENDPOINTS.DELETE_GROUP}/${id}`);
    return res.data;
};

const getAssetGroupIds = async (): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.GET_ASSET_GROUP_IDS);
    return res.data;
};

const getAssetAllItems = async (data: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.GET_ASSET_ITEMS, data);
    return res.data;
};

const addAssetItem = async (data: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.ADD_ASSET_ITEMS, data);
    return res.data;
};

const deleteItemById = async (id: number): Promise<ApiResponse<any>> => {
    const res = await privateRequest.delete<ApiResponse<any>>(`${ENDPOINTS.ASSET_ITEMS_BY_ID}/${id}`);
    return res.data;
};

const getAssetItemsById = async (id: number): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(`${ENDPOINTS.ASSET_ITEMS_BY_ID}/${id}`);
    return res.data;
};

const getAssetItemsVendor = async (): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.GET_ASSET_ITEMS_VENDOR);
    return res.data;
};

const updateAssetItemsBulkUpload = async (data: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.UPDATE_ASSET_ITEMS_BULK_UPLOAD, data);
    return res.data;
};

const getAssetItemsBulkUploadFiles = async (data: any) => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.ASSET_ITEMS_BULK_UPLOAD_FILES, { params: data });
    return res.data;
};

const getAssetItemsBulkUploadReport = async (data: any) => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.ASSET_ITEMS_BULK_UPLOAD_REPORT, { params: data, responseType: "arraybuffer" });
    return res;
};

const getAssetItemsBulkUploadLogs = async (data: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.ASSET_ITEMS_BULK_UPLOAD_LOGS, { params: data });
    return res.data;
};

const getAssetItemsByIdFiles = async (id: number, data: { type: string }): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get(`${ENDPOINTS.ASSET_ITEMS_BY_ID}/${id}/Files`, { params: data });
    return res.data;
};

const addAssetItemsByIdFiles = async (data: { id: number, logId: number, type: string, formData: any }): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post(
        `${ENDPOINTS.ASSET_ITEMS_BY_ID}/${data.id}/Files?logId=${data.logId}&type=${data.type}`,
        data.formData
    );
    return res.data;
};

const getAssetAllLocations = async (data: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.GET_ASSET_LOCATION, data);
    return res.data;
};

const addAssetLocation = async (data: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.ADD_ASSET_LOCATION, data);
    return res.data;
};

const deleteLocationById = async (id: number): Promise<ApiResponse<any>> => {
    const res = await privateRequest.delete<ApiResponse<any>>(`${ENDPOINTS.DELETE_LOCATION}/${id}`);
    return res.data;
};

const getAssetAllTypes = async (data: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.GET_ASSET_TYPE, data);
    return res.data;
};

const addAssetType = async (data: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.ADD_ASSET_TYPE, data);
    return res.data;
};

const deleteTypeById = async (id: number): Promise<ApiResponse<any>> => {
    const res = await privateRequest.delete<ApiResponse<any>>(`${ENDPOINTS.DELETE_TYPE}/${id}`);
    return res.data;
};

const getLocationNames = async (): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.GET_LOCATION_NAME);
    return res.data;
};

const getLocationTypes = async (): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.GET_LOCATION_TYPE);
    return res.data;
};

const getTypeNames = async (data: { groupId: number }): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.GET_TYPE_NAME, { params: data });
    return res.data;
};

const getAssetItemNames = async (data: { typeId: number }): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.GET_ASSET_ITEM_NAME, { params: data });
    return res.data;
};

const getAllocationGroups = async (data: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.GET_ALLOCATION_GROUPS, { params: data });
    return res.data;
};

const getAllocationItem = async (data: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.GET_ALLOCATION_ITEM, data);
    return res.data;
};

const updateAllocationItem = async (data: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.UPDATE_ALLOCATION_ITEM, data);
    return res.data;
};

const getAllocationExport = async (data: any) => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.ALLOCATION_EXPORT, data, { responseType: "arraybuffer" });
    return res;
};

const getAssetItemExport = async (data: any) => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.ITEM_EXPORT, data, { responseType: "arraybuffer" });
    return res;
};

const getReportDownloadFile = async (fileId: number) => {
    const res = await privateRequest.get<ApiResponse<any>>(`${ENDPOINTS.EXPORT_FILE}/${fileId}`, { responseType: "arraybuffer" });
    return res;
};

const getAllocationTypeExport = async (data: any) => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.EXPORT_ALLOCATION_TYPE, data, { responseType: "arraybuffer" });
    return res;
};

const getAllocationGroupExport = async (data: any) => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.EXPORT_ALLOCATION_GROUP, { params: data, responseType: "arraybuffer" });
    return res;
};

const getGroupExport = async (data: any) => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.EXPORT_GROUP, data, { responseType: "arraybuffer" });
    return res;
};

const getTypeExport = async (data: any) => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.EXPORT_TYPE, data, { responseType: "arraybuffer" });
    return res;
};

const getLocationExport = async (data: any) => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.EXPORT_LOCATION, data, { responseType: "arraybuffer" });
    return res;
};

const getAllocationLogs = async (data: { assetId: number, from: number, to: number }): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(`${ENDPOINTS.ALLOCATION_LOGS}`, {}, { params: data });
    return res.data;
};

const AssetManagement = {
    getAssetAllGroups,
    addAssetGroup,
    deleteGroupById,
    getAssetGroupIds,
    getAssetAllItems,
    addAssetItem,
    deleteItemById,
    getAssetItemsById,
    getAssetItemsVendor,
    updateAssetItemsBulkUpload,
    getAssetItemsBulkUploadFiles,
    getAssetItemsBulkUploadReport,
    getAssetItemsBulkUploadLogs,
    addAssetItemsByIdFiles,
    getAssetAllLocations,
    addAssetLocation,
    deleteLocationById,
    getAssetAllTypes,
    addAssetType,
    deleteTypeById,
    getLocationNames,
    getLocationTypes,
    getTypeNames,
    getAssetItemNames,
    getAllocationGroups,
    getAllocationItem,
    updateAllocationItem,
    getAllocationExport,
    getAssetItemExport,
    getReportDownloadFile,
    getAllocationTypeExport,
    getAllocationGroupExport,
    getGroupExport,
    getTypeExport,
    getLocationExport,
    getAllocationLogs,
    getAssetItemsByIdFiles,
};

export default AssetManagement;